<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="hidden">
    <vs-sidebar
      :hover-expand="isHoverExpand"
      :reduce="isSideBarReduce"
      :open="isOpenSideBar"
      v-model="name"
    >
      <template #logo>
        <!-- ...img logo -->
        <router-link to="/">
          <img src="@/assets/images/SPRINT_GAMING_PNG-.png" />
        </router-link>
      </template>
      <div v-for="(item, index) in getMenu(currentRole)" :key="index">
        <template v-if="item.required">
          <vs-sidebar-item
            v-if="!item.isTitle && !item.subItems && !item.required.beAdmin"
            :id="item.link"
          >
            <template #icon v-if="item.icon">
              <router-link :to="item.link">
                <i :class="item.icon"></i>
              </router-link>
            </template>
            <router-link :to="item.link">
              {{ item.label }}
            </router-link>
          </vs-sidebar-item>

          <!-- GRUPOS -->

          <vs-sidebar-group v-if="item.subItems && !item.required.notShow">
            <!-- Cabecera -->
            <template #header>
              <vs-sidebar-item arrow v-if="!item.required.beAdmin">
                <template #icon v-if="item.icon">
                  <i :class="item.icon"></i>
                </template>
                {{ item.label }}
              </vs-sidebar-item>
            </template>
            <!-- Fin Cabecera -->
            <vs-sidebar-item
              v-for="(subI, index) in item.subItems"
              :key="index"
              :id="subI.link"
            >
              <template #icon v-if="subI.icon">
                <template v-if="subI.required">
                  <template v-if="!subI.required.beAdmin">
                    <router-link :to="subI.link">
                      <i
                        :class="subI.icon"
                        :style="`display: ${
                          !subI.required.beAdmin ? 'block' : 'none'
                        }`"
                      ></i>
                    </router-link>
                  </template>
                </template>
              </template>
              <template v-if="subI.required">
                <template v-if="!subI.required.beAdmin">
                  <router-link
                    :to="subI.link"
                    :style="`display: ${
                      !subI.required.beAdmin ? 'block' : 'none'
                    }`"
                  >
                    {{ subI.label }}
                  </router-link>
                </template>
              </template>
            </vs-sidebar-item>
          </vs-sidebar-group>
        </template>
        <template v-else>
          <vs-sidebar-item
            v-if="!item.isTitle && !item.subItems"
            :id="item.link"
          >
            <template #icon v-if="item.icon">
              <router-link :to="item.link">
                <i :class="item.icon"></i>
              </router-link>
            </template>
            <router-link :to="item.link">
              {{ item.label }}
            </router-link>
          </vs-sidebar-item>

          <!-- GRUPOS -->

          <vs-sidebar-group v-if="item.subItems">
            <!-- Cabecera -->
            <template #header>
              <vs-sidebar-item arrow>
                <template #icon v-if="item.icon">
                  <i :class="item.icon"></i>
                </template>
                {{ item.label }}
              </vs-sidebar-item>
            </template>
            <!-- Fin Cabecera -->
            <vs-sidebar-item
              v-for="(subI, index) in item.subItems"
              :key="index"
              :id="subI.link"
              :style="`display: ${subI.required.beAdmin ? 'flex' : 'none'}`"
            >
              <template #icon v-if="subI.icon && subI.required.beAdmin">
                <router-link :to="subI.link">
                  <i
                    :class="subI.icon"
                    :style="`display: ${
                      subI.required.beAdmin ? 'block' : 'none'
                    }`"
                  ></i>
                </router-link>
              </template>
              <router-link
                :to="subI.link"
                :style="`display: ${subI.required.beAdmin ? 'block' : 'none'}`"
              >
                {{ subI.label }}
              </router-link>
            </vs-sidebar-item>
          </vs-sidebar-group>
        </template>
      </div>
    </vs-sidebar>
  </div>
  <!-- Left Sidebar End -->
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

/**
 * Sidebar component
 */
export default {
  data() {
    return {
      active: 'Inicio',
      name: this.routeName,
    };
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
    routeName: {
      type: String,
    },
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'dark':
              document.body.setAttribute('data-sidebar', 'dark');
              document.body.removeAttribute('data-topbar');
              document.body.removeAttribute('data-sidebar-size');
              break;
            case 'light':
              document.body.removeAttribute('data-sidebar');
              document.body.removeAttribute('data-sidebar-size');
              document.body.classList.remove('vertical-collpsed');
              break;
            case 'compact':
              document.body.setAttribute('data-sidebar-size', 'small');
              document.body.setAttribute('data-sidebar', 'dark');
              document.body.classList.remove('vertical-collpsed');
              document.body.removeAttribute('data-topbar', 'dark');
              break;
            case 'icon':
              document.body.setAttribute('data-keep-enlarged', 'true');
              document.body.classList.add('vertical-collpsed');
              document.body.setAttribute('data-sidebar', 'dark');
              document.body.removeAttribute('data-topbar', 'dark');
              break;
            case 'colored':
              document.body.setAttribute('data-sidebar', 'colored');
              document.body.removeAttribute('data-keep-enlarged');
              document.body.classList.remove('vertical-collpsed');
              document.body.removeAttribute('data-sidebar-size');
              break;
            default:
              document.body.setAttribute('data-sidebar', 'dark');
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'boxed':
              document.body.setAttribute('data-layout-size', 'boxed');
              break;
            case 'fluid':
              document.body.setAttribute('data-layout-mode', 'fluid');
              document.body.removeAttribute('data-layout-size');
              break;
            default:
              document.body.setAttribute('data-layout-mode', 'fluid');
              break;
          }
        }
      },
    },
    $route: {
      handler: 'onRoutechange',
      immediate: true,
      deep: true,
    },
    routeName(value) {
      this.name = value;
    },
  },
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    /**
     * remove active and mm-active class
     */
    _removeAllClass(className) {
      const els = document.getElementsByClassName(className);
      while (els[0]) {
        els[0].classList.remove(className);
      }
    },
    onRoutechange() {
      setTimeout(() => {
        if (document.getElementsByClassName('mm-active').length > 0) {
          const currentPosition =
            document.getElementsByClassName('mm-active')[0].offsetTop;
          if (currentPosition > 500)
            this.$refs.currentMenu.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
        }
      }, 300);
    },
    ...mapMutations({
      toggleSideBar: 'menu/toggleSideBar',
    }),
  },
  computed: {
    user() {
      const user = JSON.parse(localStorage.getItem('user'));
      return user;
    },
    role() {
      return this.$store.getters['user/getUserRole'];
    },
    /**
     * Rol normalizado que se pasa a getMenu. Prioriza el store (reactivo
     * a login/logout/cambio de rol) y solo cae a localStorage si el store
     * todavía no esta hidratado.
     */
    currentRole() {
      if (this.role) {
        return typeof this.role === 'string'
          ? this.role
          : this.role.name;
      }
      const cached = JSON.parse(localStorage.getItem('user') || 'null');
      return cached?.user?.role?.name || '';
    },
    ...mapGetters({
      getMenu: 'menu/getMenu',
      isSideBarReduce: 'menu/isSideBarReduce',
      isHoverExpand: 'menu/isHoverExpand',
      isOpenSideBar: 'menu/isOpenSideBar',
    }),
  },
  mounted() {
    // El menu se construye reactivamente desde `currentRole` (computed).
    // No requiere lectura imperativa de localStorage aqui.
  },
};
</script>

<style scoped>
.logo-sm {
  height: auto;
  width: 100px;
  margin: 0 auto;
  position: relative;
  left: 0;
}

.logo-img {
  height: 70px;
  width: auto;
  object-fit: cover;
  margin: 0 auto;
  display: block;
}

.min-logo {
  height: auto;
  width: 250%;
  object-fit: cover;
}
</style>
